import { useTranslation } from "react-i18next";
import React from "react";
import { icAsset } from "../../../components/image/image-src";

interface CardInfo {
  title: string;
  value: string;
}

interface TourCardProps {
  id: number;
  name: string;
  date: string | null;
  success: boolean;
  message: string;
  cardInfo: CardInfo[];
  isChecked: boolean;
  onCheckboxChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    tourId: number,
  ) => void;
  onSelectTime: () => void;
}

export const TourCard: React.FC<TourCardProps> = ({
  id,
  name,
  date,
  success,
  message,
  cardInfo,
  isChecked,
  onCheckboxChange,
  onSelectTime,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex w-full justify-between py-8 ${
        id === 1 ? "border-t border-[#DCDCDC]" : ""
      }`}
    >
      <div className="flex gap-4">
        <div className="content-center">
          <input
            style={{
              visibility: !success ? "hidden" : "visible",
            }}
            type="checkbox"
            className="custom-checkbox"
            id={`tour-${id}`}
            checked={isChecked}
            onChange={(e) => onCheckboxChange(e, id)}
          />
        </div>

        <div className="flex gap-5">
          <div className="h-[6.25rem] w-[6.25rem]">
            <img
              className={`h-[6.25rem] w-[6.25rem] ${
                !success ? "opacity-40" : ""
              }`}
              src={icAsset("../../assets/images/example-1.png")}
              alt=""
            />
            <p
              className="w-[38rem] pt-1 text-[#DA3838]"
              style={{ display: !success ? "block" : "none" }}
            >
              {message}
            </p>
          </div>
          <div>
            <div className="flex justify-between" style={{ width: "39rem" }}>
              <p
                className={`mb-2 text-[1.25rem] font-semibold leading-[1.7025rem] text-[#232323] ${
                  !success ? "opacity-30" : ""
                }`}
              >
                {name}
              </p>
              {date == null && (
                <button
                  type="button"
                  onClick={onSelectTime}
                  className="rounded-full border border-gray-300 bg-white px-4 py-2 text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {t("Select time")}
                </button>
              )}
            </div>

            <div
              className={`flex flex-col gap-2 ${!success ? "opacity-40" : ""}`}
            >
              {cardInfo
                .filter((info) => info.value)
                .map((info, index) => (
                  <p
                    key={index}
                    className="text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]"
                  >
                    <span className="font-semibold">{info.title}:</span>{" "}
                    {info.value}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
